const apiUrl = process.env.REACT_APP_API_URL;
export const GetBbddActivitats = async (id: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/bbdd/usuaris/${id}/activitats`);
        const data = await response.json();
        if (Array.isArray(data)) {
            return data;
        }
        if (typeof data === 'string') {
            try {
                const parsed = JSON.parse(data);
                return Array.isArray(parsed) ? parsed : [];
            } catch (e) {
                return [];
            }
        }
        if (data && data.json) {
            try {
                const parsed = typeof data.json === 'string' ? JSON.parse(data.json) : data.json;
                return Array.isArray(parsed) ? parsed : [];
            } catch (e) {
                return [];
            }
        }
        return [];
    } catch (error) {
        console.log('Error al obtener los datos:', error);
        return [];
    }
};

